/**
 * Archelios MAP
 * (c) Cythelia Energy
 */
var am = (function (namespace) {
	// Adaptated from the native Leaflet handler "ScrollWheelZoom"
    namespace.MapScrollHandler = L.Handler.extend({
        addHooks: function () {
            L.DomEvent.on(this._map._container, 'mousewheel', this._onWheelScroll, this);

            this._delta = 0;
        },

        removeHooks: function () {
            L.DomEvent.off(this._map._container, 'mousewheel', this._onWheelScroll, this);
        },

        _onWheelScroll: function (e) {
            var delta = L.DomEvent.getWheelDelta(e);

            var debounce = this._map.options.wheelDebounceTime;

            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            this._shiftKeyPressed = e.shiftKey;

            if (!this._startTime) {
                this._startTime = +new Date();
            }

            var left = Math.max(debounce - (+new Date() - this._startTime), 0);

            clearTimeout(this._timer);
            this._timer = setTimeout(L.Util.bind(this._performZoom, this), left);

            stop(e);
        },

        _performZoom: function () {
            var map = this._map,
                zoom = map.getZoom(),
                snap = this._map.options.zoomSnap || 0;

            map._stop(); // stop panning and fly animations if any

            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
                d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
                d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
                d5 = d4 * (this._shiftKeyPressed ? 3 : 1),
                delta = map._limitZoom(zoom + (this._delta > 0 ? d5 : -d5)) - zoom;

            this._delta = 0;
            this._startTime = null;

            if (!delta) { return; }

            if (map.options.scrollWheelZoom === 'center') {
                map.setZoom(zoom + delta);
            } else {
                map.setZoomAround(this._lastMousePos, zoom + delta);
            }
        }
    });

    // Make the handler available in all newly created maps
    L.Map.addInitHook('addHandler', 'myScrollWheelZoom', namespace.MapScrollHandler);

    return namespace;
})(am || {});